"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OFFLINE_VALIDITY_GRACE_PERIOD_DAYS = exports.DEFAULT_DAYS_VALID_OFFLINE = exports.CONNECTED_CLIENTS_LIMIT = void 0;
exports.activeLicenseKeyInfo = activeLicenseKeyInfo;
exports.defaultLicenseKeyInfo = defaultLicenseKeyInfo;
exports.isLicenseKeyExpired = isLicenseKeyExpired;
exports.countActiveLicenseKeys = countActiveLicenseKeys;
exports.countActiveSubscriptionLicenseKeys = countActiveSubscriptionLicenseKeys;
const date_1 = require("./date");
const subscriptions_1 = require("./subscriptions");
exports.CONNECTED_CLIENTS_LIMIT = {
    lite: 2,
    plus_v2: 15,
    /** @deprecated */ pro: 15,
    pro_v2: 50,
    /** @deprecated */ premium: Infinity,
    premium_v2: 100,
    /** @deprecated */ ultimate: Infinity,
    ultimate_v2: Infinity,
};
exports.DEFAULT_DAYS_VALID_OFFLINE = 7;
exports.OFFLINE_VALIDITY_GRACE_PERIOD_DAYS = 7;
function activeLicenseKeyInfo(licenseKey, subscription, now = Date.now()) {
    var _a;
    const endMillis = (() => {
        if (licenseKey.end) {
            return (0, date_1.toMillis)(subscription ? (0, subscriptions_1.subscriptionEnd)(subscription) : licenseKey.end);
        }
        else {
            return Infinity;
        }
    })();
    const endWithGracePeriod = (0, date_1.daysFrom)(endMillis, exports.OFFLINE_VALIDITY_GRACE_PERIOD_DAYS);
    if (now >= endWithGracePeriod) {
        return null;
    }
    let offlineExpiry = endWithGracePeriod;
    if (!subscription) {
        offlineExpiry = Math.min(offlineExpiry, now + ((_a = licenseKey.daysValidOffline) !== null && _a !== void 0 ? _a : Infinity) * date_1.ONE_DAY_IN_MILLS);
    }
    return Object.assign(Object.assign({}, (endMillis < Infinity && { end: endMillis })), { offlineExpiry, tier: licenseKey.tier, generated: now, restrictToMaxMajorVersion: licenseKey.restrictToMaxMajorVersion });
}
function defaultLicenseKeyInfo(now = Date.now()) {
    return {
        generated: now,
        tier: 'lite',
        offlineExpiry: Infinity,
    };
}
function isLicenseKeyExpired(licenseKey, now = Date.now()) {
    if (licenseKey.end) {
        return now >= (0, date_1.toMillis)(licenseKey.end);
    }
    else {
        return false; // never expires
    }
}
function countActiveLicenseKeys(licenseKeys, tier) {
    return licenseKeys.filter(([, key]) => (!tier || key.tier === tier) && !isLicenseKeyExpired(key))
        .length;
}
function countActiveSubscriptionLicenseKeys(subscriptions, tier, now = Date.now()) {
    return subscriptions
        .filter(([, sub]) => !(0, subscriptions_1.hasSubscriptionEnded)(sub, now))
        .reduce((total, [, sub]) => total +
        sub.items
            .filter((item) => {
            var _a, _b;
            return tier
                ? ((_a = item.price.product.metadata) === null || _a === void 0 ? void 0 : _a.cogs_license) === tier
                : (_b = item.price.product.metadata) === null || _b === void 0 ? void 0 : _b.cogs_license;
        })
            .reduce((total, item) => total + item.quantity, 0), 0);
}
//# sourceMappingURL=licenses.js.map